export const Shopping = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 19C18.6716 19 18 19.6716 18 20.5C18 21.3284 18.6716 22 19.5 22C20.3284 22 21 21.3284 21 20.5C21 19.6716 20.3284 19 19.5 19ZM19.5 19H5.23077C3.44646 19 2.5 18.2188 2.5 17C2.5 15.7812 3.44646 15 5.23077 15H7M15.5 15H20L22 4H16.5M20 15H7M5 4L7 15M5 4H10.75M5 4C4.83333 3.33333 4 2 2 2M7 15H11.5M16.5 4L15.5 15M16.5 4H10.75M15.5 15H11.5M10.75 4L11.5 15M11 20.5C11 21.3284 10.3284 22 9.5 22C8.67157 22 8 21.3284 8 20.5C8 19.6716 8.67157 19 9.5 19C10.3284 19 11 19.6716 11 20.5Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
